<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="日期">
                    <el-date-picker v-model="dateTimer" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="客户名称">
                    <el-input v-model="params.credit_customer_name" placeholder="请输入完整的客户名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCreditMarkScores(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                评分列表
                <el-dropdown trigger="click">
                    <el-button type="primary">
                        导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="getCreditMarkScoresrExport()">导出查询信息</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-table :data="tableData" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="Credit_Customer_Name" label="客户名称" align="center" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Credit_MarkScore_InitialAmount" label="基本合作规模" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_MarkScore_LawyerLetterAmount" label="律师函调整金额" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_MarkScore_InitialScore" label="催款函调整金额" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_MarkScore_RepaymentPlanAmount" label="还款计划调整" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_MarkScore_InitialScore" label="基本得分" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_MarkScore_OverdueReturnScore" label="客户逾期欠款调整分" align="center" width="180"></el-table-column>
                <el-table-column prop="Credit_MarkScore_WrittenScore" label="书面计划完成率调整分" align="center" width="180"></el-table-column>
                <el-table-column prop="Credit_MarkScore_WrittenScore" label="书面确认调整分" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_MarkScore_CommercialBillScore" label="商业承兑汇票调整分" align="center" width="180"></el-table-column>
                <el-table-column prop="Credit_MarkScore_TotalScore" label="最终得分" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_MarkScore_Addtime" label="评分日期" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_MarkScore_Evaluation" label="评分评价" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_MarkScore_IsReturnZero" label="评分归零" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_MarkScore_Remarks" label="归零项备注" align="center" width="120" show-overflow-tooltip></el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { toLowerCaseKeys, downloadFile } from '@/utils/utils.js';
const today = new Date().toISOString().slice(0, 10); // 格式化为 'YYYY-MM-DD'
export default {
    name: 'customerDailyrating',
    mixins: [myMixin],
    components: {
        Pagination
    },
    data() {
        return {
            loadingBtn: false,
            params: {
                credit_customer_name: '',
                date_start: '',
                date_end: ''
            },
            tableData: [
                //   {
                //   "Credit_MarkScore_ID": 80,
                //   "Credit_MarkScore_CustomerCode": "Glaer",
                //   "Credit_MarkScore_UniformCode": "Glaer",
                //   "Credit_MarkScore_Addtime": "2024-07-22",
                //   "Credit_MarkScore_InitialScore": "0.00",//基本评分
                //   "Credit_MarkScore_InitialAmount": "0.00",//基本合作模式
                //   "Credit_MarkScore_LawyerLetterAmount": "0.00",//律师函调整金额
                //   "Credit_MarkScore_ReminderLetterAmount": "0.00",//催款函调整金额
                //   "Credit_MarkScore_RepaymentPlanAmount": "0.00",//口头/书面还款计划调整金额
                //   "Credit_MarkScore_OverdueReturnScore": "0.00",//客户逾期欠款调整分数
                //   "Credit_MarkScore_OnTimeRateScore": "0.00",//完成率调整分
                //   "Credit_MarkScore_WrittenScore": "0.00",//书面欠款确认调整分
                //   "Credit_MarkScore_TotalScore": "0.00",//最终得分
                //   "Credit_MarkScore_Evaluation": "--",//评分评价
                //   "Credit_MarkScore_CommercialBillScore": "0.00",//商业承兑汇票调整分
                //   "Credit_MarkScore_IsReturnZero": "否",//评分归零
                //   "Credit_MarkScore_Remarks": "",//归零备注
                //   "Credit_Customer_Name": "北京光蓝网络科技有限公司"//客户名称
                // }
            ],
            dateTimer: [today, today]
        };
    },
    mounted() {
        this.getCreditMarkScores();
    },
    methods: {
        onRefresh() {
            this.dateTimer = [today, today];
            this.getCreditMarkScores(true);
        },
        getCreditMarkScores(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getCreditMarkScores(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = { ...this.params };
            if (this.dateTimer && this.dateTimer.length > 0) {
                params.date_start = this.dateTimer[0];
                params.date_end = this.dateTimer[1];
            }
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        /*
  导出查询列表结果
*/
        getCreditMarkScoresrExport() {
            this.$newsApi
                .getCreditMarkScoresrExport(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        downloadFile(res.data.data, res.data.Resultinfo);
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        /*分页查询*/
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.paginationOptions.Page = 1;
            this.getCreditMarkScores();
        },
        /*分页查询*/
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getCreditMarkScores();
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__label {
    font-weight: 500 !important;
}
.content {
    // padding: 10px 10px;
    height: calc(100vh - 104px);
    overflow: auto;
}
.content-head {
    background: #fff;
    padding: 0px 20px 20px 20px;
    border-radius: 2px;
}
.content-head-title {
    line-height: 50px;
}
.content-table-title {
    display: flex;
    justify-content: space-between;
    line-height: 50px;
}
.content-table {
    border-radius: 2px;
    background: #fff;
    padding: 0px 20px 20px 20px;
    cursor: pointer;
    margin-top: 10px;
}
.description-view {
    padding: 0px 20px;
}
</style>
